<template>
  <div :class="classes">
    <div v-click-outside="closeOutside">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: "RoeModal",
  props: {
    wrapClass: {
      type: String,
      required: false
    },
    closeOnClickOutside: {
      type: Boolean,
      required: false,
      default() {
        return true;
      }
    },
    isOpen: {
      type: Boolean,
      required: false,
      default() {
        return false;
      }
    }
  },
  data() {
    return {
      isOpenState: this.isOpen
    };
  },
  computed: {
    classes() {
      return this.wrapClass + (this.isOpenState ? " opened" : "");
    }
  },
  methods: {
    open() {
      this.isOpenState = true;
    },
    close() {
      if (!this.isOpenState) return false;
      this.isOpenState = false;
      return true;
    },
    closeOutside() {
      if (this.closeOnClickOutside) this.close();
    },
    changeState() {
      this.isOpenState = !this.isOpenState;
    }
  }
};
</script>
